import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { fetchError, fetchSuccess } from './actions'
import { SummaryActionTypes } from './types'
import { getWidget } from '../../services/test'

// const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3000'

function* handleFetch():any {
  try {
    const res = yield call(getWidget)

    if (res === null) {
      yield put(fetchError('Error, data is null or sessions expired.'))
    } else {
      yield put(fetchSuccess(res))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(fetchError(err.stack))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

function* watchFetchRequest() {
  yield takeEvery(SummaryActionTypes.FETCH_REQUEST, handleFetch)
}

function* summarySaga() {
  yield all([fork(watchFetchRequest)])
}

export default summarySaga
